if (!customElements.get('program-carousel')) {
  customElements.define('program-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.programs__track');
      this.items = [...this.track.children];
      if (this.items.length < 2) return;

      // A second copy makes the end meet the beginning without a rewind.
      // Copies stay clickable but are omitted from keyboard and screen-reader navigation.
      this.clones = this.items.map((item) => {
        const clone = item.cloneNode(true);
        clone.dataset.clone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        clone.querySelectorAll('a').forEach((link) => link.tabIndex = -1);
        this.track.append(clone);
        return clone;
      });
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.position = this.track.scrollLeft;
      this.hovered = false;
      this.touching = false;
      this.pauseUntil = 0;
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.hovered = true;
      }, options);
      this.addEventListener('pointerleave', () => this.hovered = false, options);
      this.track.addEventListener('pointerdown', () => this.touching = true, options);
      const release = () => { this.touching = false; this.pauseUntil = performance.now() + 2000; };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.track.addEventListener('wheel', () => this.pauseUntil = performance.now() + 2000, { ...options, passive: true });
      this.track.addEventListener('focusin', (event) => {
        const item = event.target.closest('.programs__item');
        if (item) this.track.scrollTo({ left: item.offsetLeft - this.items[0].offsetLeft, behavior: 'instant' });
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('.programs__item');
        if (item) this.track.scrollTo({ left: item.offsetLeft - this.items[0].offsetLeft, behavior: 'instant' });
      }, options);
      this.motion.addEventListener('change', () => {
        this.track.scrollLeft = 0;
        this.position = 0;
      }, options);
      this.observer = new ResizeObserver(() => {
        this.distance = this.clones[0].offsetLeft - this.items[0].offsetLeft;
        this.position = this.track.scrollLeft;
      });
      this.observer.observe(this.track);

      const animate = (now) => {
        const elapsed = Math.min(now - (this.lastFrame || now), 50);
        this.lastFrame = now;
        const rect = this.track.getBoundingClientRect();
        const paused = this.motion.matches || this.hovered || this.touching ||
          this.matches(':focus-within') || now < this.pauseUntil || document.hidden ||
          rect.bottom < 0 || rect.top > innerHeight || window.Shopify?.designMode;
        if (paused || !this.distance) {
          this.position = this.track.scrollLeft;
        } else {
          this.position = (this.position + elapsed * 0.024) % this.distance;
          this.track.scrollLeft = this.position;
        }
        this.frame = requestAnimationFrame(animate);
      };
      this.frame = requestAnimationFrame(animate);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.observer?.disconnect();
      this.clones?.forEach((clone) => clone.remove());
      this.lastFrame = 0;
    }
  });
}
